import _ from "lodash";

import {
  Component,
} from "react";
import {
  Alert,
  Col,
  Row,
} from "react-bootstrap";
import {
  withLocation,
} from "CommonCore/router-util";
import qs from "qs";

import store from "CommonState/store";
import {
  ControlGenerators,
} from "CommonComponents/detail-view";
import {
  Panel,
} from "CommonComponents/bricks";
import logo from "../img/logo.png";

@store
@withLocation
export default class ResetPage extends Component {
  constructor() {
    super();
    this.state = {
      password: "",
    };
  }

  render() {
    const { errorMessage, errorFlashToggle } = this.state;
    const cg = (label, name, type, required, helptext) => {
      const setValue = (schema, value) => {
        this.setState({ [name]: value });
      };
      return ControlGenerators.default({
        entity: this.state,
        leftCol: 5,
        rightCol: 6,
        schema: { display: label, field: name, type: type, required: required, helpText: helptext },
        onChange: setValue,
      });
    };
    return (
      <div className='middle-box text-center loginscreen-wide'>
        <div>
          <div>
            <img src={logo} />
          </div>
          <h3>Willkommen im e-Portal</h3>
          <p>Einstellungsportal der Bergischen Universität Wuppertal</p>

          <form action={null} className='m-t' role='form' onSubmit={this.process}>
            {errorMessage && <Alert
              variant='danger'
              className={"flash" + (errorFlashToggle + 1)}>
              {errorMessage}</Alert>}

            <Panel className='text-left'>
              <h3 className='text-center'>Passwort ändern</h3><br />
              <div className='form-horizontal'>
                {cg("Passwort", "password", "password", true, "Bitte geben Sie ein Passwort mit mindestens 8 Zeichen ein, darunter sowohl Buchstaben als auch Zahlen")}
                {cg("Passwort Wiederholung", "password_repeat", "password", true, "Bitte geben Sie zur Sicherheit das eingegebene Passwort erneut ein")}
                <Row>
                  <Col sm={5} />
                  <Col sm={6} className='required' style={{ paddingTop: "6px" }}>Pflichtfelder</Col>
                </Row>
              </div>
              <button type='submit' className='float-end btn btn-primary m-b'>Passwort ändern</button>
            </Panel>
          </form>

          <p className='m-t'> <small>ProUnix GmbH - e-Portal</small> </p>

        </div>
      </div>);
  }

  process = e => {
    e.preventDefault();
    const { password, password_repeat } = this.state;
    const { location, history } = this.props;

    this.setState({ errorMessage: null });

    // Validierung
    if (_.isEmpty(password)) {
      this.setState(prevState => ({
        errorMessage: "Bitte geben Sie ein Passwort ein",
        errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
      }));
      return false;
    }
    if (_.isEmpty(password_repeat)) {
      this.setState(prevState => ({
        errorMessage: "Bitte wiederholen Sie die Passwort-Eingabe",
        errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
      }));
      return false;
    }
    if (password !== password_repeat) {
      this.setState(prevState => ({
        errorMessage: "Die Passwortwiederholung stimmt nicht mit der Eingabe überein",
        errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
      }));
      return false;
    }
    if (_.isEmpty(password_repeat)) {
      this.setState(prevState => ({
        errorMessage: "Bitte wiederholen Sie die Passwort-Eingabe",
        errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
      }));
      return false;
    }

    // Link für Passwortänderung zusenden
    const reset = async() => {
      try {
        await fetch(`/api/shkauthentifizierung/vergessen/passwort?v=${ location && qs.parse(location.search, { ignoreQueryPrefix: true }).v }`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          method: "POST",
          body: JSON.stringify({ passwort: password }),
        });
        history.replace("/");
      } catch(err) {
        this.setState(prevState => ({
          errorMessage: "Fehler beim Zurücksetzen",
          errorFlashToggle: 1 - (prevState.errorFlashToggle || 0),
        }));
      }
    };
    reset();
  };
}
